import localStorageWrapper from '../../utils/localStorageWrapper';
export function getCompliantLocalStorageItem(state, key) {
    if (typeof window === 'undefined') {
        return null;
    }
    return localStorageWrapper.getItem(key);
}
